import React from "react";
import ToggleButton from "@material-ui/lab/ToggleButton";
import ToggleButtonGroup from "@material-ui/lab/ToggleButtonGroup";
import { inject, observer } from "mobx-react";
import { CalculateStore } from "../../../../stores/calculateStore";
import Notification from "../../../sharedComponents/notification/notification";
import { UiFlagsStore } from "../../../../stores/uiFlagsStore";
import { FormControl, FormHelperText } from "@material-ui/core";
import { TypeOfActivityId } from "../../../../helpers/additionalQuestions/typeOfActivity";
import { ErrorMessages } from "../../../../helpers/errorMessage";
import { BusinessActivityId } from "../../../../helpers/additionalQuestions/businessActivity";
import { CalculationService } from "../../../../services/services/calculationService";

interface BusinessActivityInBuildingProps {
  calculateStore?: CalculateStore;
  calculationService?: CalculationService;
  uiFlagsStore?: UiFlagsStore;
  displayTypeOfActivityQuestion: (display: boolean) => void;
}

export function BusinessActivityInBuilding(props: BusinessActivityInBuildingProps) {

  const calculateStore = props.calculateStore!;
  const businessActivity = calculateStore.additionalQuestions.businessActivityInBuilding.value;

  const onChangeValue = (event: React.MouseEvent<HTMLElement>, newValue: BusinessActivityId) => {
    if (newValue) {
      calculateStore.setBusinessActivityInBuildingValue(newValue);
      checkDisplayTypeOfActivity(newValue);
      validate();
    }
  };

  function checkDisplayTypeOfActivity(newValue: BusinessActivityId) {
    if (newValue === BusinessActivityId.under50percent) {
      props.displayTypeOfActivityQuestion(true);
      calculateStore.setTypeOfActivity(TypeOfActivityId.registered);
    } else {
      props.displayTypeOfActivityQuestion(false);
      props.calculationService!.setRisksNetworkForAllPackages();
    }
  }

  return (
    <div className="additional-questions-section business-activity-in-building">
      <div className="question-answer-container">
        <div className="question">Czy w miejscu ubezpieczenia jest prowadzona działalność gospodarcza?</div>
        <FormControl>
          <ToggleButtonGroup
            value={businessActivity}
            exclusive
            onChange={onChangeValue}
            onBlur={validate}
            orientation={props.uiFlagsStore!.isMobile ? "vertical" : "horizontal"}
          >
            <ToggleButton
              value={BusinessActivityId.under50percent}
              className={getClassNameForButton()}>
              Tak, do 50% powierzchni
            </ToggleButton>
            <ToggleButton
              value={BusinessActivityId.over50percent}
              className={getClassNameForButton()}>
              Tak, powyżej 50% powierzchni
            </ToggleButton>
            <ToggleButton
              value={BusinessActivityId.no}
              className={getClassNameForButton()}>
              Nie
            </ToggleButton>
          </ToggleButtonGroup>
          {!!calculateStore.additionalQuestions.businessActivityInBuilding.errorMessage && (
            <FormHelperText>
              <Notification type="error" message={calculateStore.additionalQuestions.businessActivityInBuilding.errorMessage} />
            </FormHelperText>
          )}
        </FormControl>
      </div>
      <div>
        {businessActivity === BusinessActivityId.over50percent && <Notification type="error"
          message={ErrorMessages.businessActivity.over50percent} />}
      </div>
    </div>
  );

  function validate() {
    calculateStore.additionalQuestions.businessActivityInBuilding.validateBusinessActivity();
  }

  function getClassNameForButton(): string {
    return !!calculateStore.additionalQuestions.businessActivityInBuilding.errorMessage ? "radio-button error-button" : "radio-button";
  }
}

export default inject("calculateStore", "uiFlagsStore", "calculationService")(observer(BusinessActivityInBuilding));
